import React from 'react';
import './styles/style.css';

const IconButton = ({
  icon,
  onClick,
  intent = 'primary',  // 'primary' | 'danger' | 'warning'
  type = 'button',
  title,
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <button
      type={type}
      className={`iconButton iconButton--${intent} ${disabled ? 'disabled' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      title={title}
      {...props}
    >
      <span className="iconButton-icon material-symbols-sharp" translate="no">{icon}</span>
    </button>
  );
};

export default IconButton;